var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 7c.713 0 1.21 0 1.592.04.375.038.585.108.741.213.164.11.305.25.414.414.105.156.175.366.213.74C6 8.792 6 9.288 6 10v5.537c0 .911 0 1.646.078 2.224.08.6.253 1.105.654 1.507.402.401.907.574 1.507.654.578.078 1.313.078 2.224.078h3.074c.911 0 1.646 0 2.224-.078.6-.08 1.105-.253 1.507-.654.401-.402.574-.907.654-1.507.078-.578.078-1.313.078-2.224V10c0-.713 0-1.21.04-1.592.038-.375.108-.585.213-.741a1.5 1.5 0 0 1 .414-.414c.156-.105.366-.175.74-.213C19.791 7 20.287 7 21 7V6H3v1Zm6.5 8a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 1 0v3a.5.5 0 0 1-.5.5Zm4.5-.5a.5.5 0 0 0 1 0v-3a.5.5 0 0 0-1 0v3Z",
    fill: "#0E1012"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 3.5s.5-1 2.5-1 2.5 1 2.5 1",
    stroke: "#0E1012",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.18957fdf56e1a9be9432110e11dc603f.svg";
export { ForwardRef as ReactComponent };